import { render, staticRenderFns } from "./domainList.vue?vue&type=template&id=cf050db6&lang=pug"
import script from "./domainList.vue?vue&type=script&lang=js"
export * from "./domainList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports